<template>
  <div>
    <div class="wrapper">
      <div class="animated fadeIn">
        <b-row>
          <b-col cols="12" class="mb-3">
            <b-button variant="primary" @click="$router.push('/admin/companies/toevoegen')" class="pull-right"
                      v-can="'bedrijven aanpassen'">Bedrijf toevoegen
            </b-button>
            <b-button @click="openImportModal" class="pull-right mr-2" v-can="'bedrijven aanpassen'">Importeren</b-button>
          </b-col>
        </b-row>
        <resource-index ref="resourceIndex" header="Bedrijven" endpoint="companies" show-route="companies.view"/> 
      </div>
    </div>
    <b-modal id="import-companies" ref="import-companies" title="Importeren" hide-footer>
      <b-tabs content>
        <b-tab title="Bedrijven" active>
          <p class="mb-4">
            Importeer bedrijven aan de hand van een .XLSX document met daarin de volgende kolommen:
          </p>
          <b-list-group class="mt-0 mb-4">
            <b-list-group-item class="pt-1 pb-1 pl-3 pr-3">1. Naam</b-list-group-item>
            <b-list-group-item class="pt-1 pb-1 pl-3 pr-3">2. Adres</b-list-group-item>
            <b-list-group-item class="pt-1 pb-1 pl-3 pr-3">3. Postcode</b-list-group-item>
            <b-list-group-item class="pt-1 pb-1 pl-3 pr-3">4. Plaats</b-list-group-item>
            <b-list-group-item class="pt-1 pb-1 pl-3 pr-3">5. Landcode</b-list-group-item>
            <b-list-group-item class="pt-1 pb-1 pl-3 pr-3">6. Moederbedrijf naam</b-list-group-item>
            <b-list-group-item class="pt-1 pb-1 pl-3 pr-3">7. Maximale bestelwaarde</b-list-group-item>
          </b-list-group>
          <b-form id="upload-form" @submit.prevent="importCompanies">
          <b-form-file
            required
            v-model="file"
            :state="Boolean(file)"
            accept=".xls, .xlsx, .csv"
            placeholder="Kies of sleep een bestand..."
            drop-placeholder="Sleep het bestand..."/>
            <b-row class="mt-2">
              <b-col>
                <hr>
                <b-button type="submit" :disabled="!file" block class="mt-4" variant="primary">Importeer</b-button>
              </b-col>
            </b-row>
          </b-form>
        </b-tab>
      </b-tabs>
    </b-modal>
  </div>
</template>

<script>
    import ResourceIndex from '../../components/ResourceIndex';
    import {uploadData} from "../../api";

    export default {
        name: 'companies',
        components: {ResourceIndex},
        data() {
            return {
                file: undefined,
            }
        },
        methods: {
            reset() {
                const $resourceIndex = this.$refs.resourceIndex;
                $resourceIndex.resetFilters();
            },
            openImportModal() {
                this.$refs['import-companies'].show()
            },
            hideImportModal() {
                this.$refs['import-companies'].hide();
            },
            async importCompanies() {
                let data = new FormData();
                data.append('file', this.file);

                let response = await uploadData('companies/import', data);
                if (response.status === 422){
                  this.$bvToast.toast(`${response.data.errors[0][0]}`, {
                      title: 'Oeps...',
                      noAutoHide: true,
                      variant: 'danger',
                  });
                } else if (response.status !== 200) {
                  this.$bvToast.toast(`Er is iets fout gegaan tijdens het importeren: ${response.data.message}`, {
                    title: 'Oeps...',
                    autoHideDelay: 5000,
                    variant: 'danger',
                  });
                } else if (response.status === 200) {
                  this.$bvToast.toast(`Importeren van bedrijven is gelukt`, {
                    title: 'Succes',
                    autoHideDelay: 5000,
                    variant: 'success',
                  });
                }

                this.hideImportModal();
            },
        },
        computed: {
            userRole() {
                return this.$store.state.userRole
            }
        },
    }
</script>
